import { lazy } from 'react';

const Mail = {
  Helmet: lazy(() => import('./Helmet')),
  PromotionMail: lazy(() => import('./PromotionMail')),
};

export default Mail;
export { PromotionMailSearchParams } from './PromotionMail/types';
